export const GIN_SEARCH_URL = '/issues/';

export const generateNinBasePath = () => GIN_SEARCH_URL;
